import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Form, Input, Checkbox, Select, Button } from 'antd'
import style from './formproperties.module.sass'
import { updateFormProperties } from "../../stateManager/store/formCreation/action";
import { updateV2FormProperties } from "../../stateManager/store/formCreation_v2/actions";
import { Modal } from '../../helpers/commonUi'

interface IProps {
    data: any
    dispatch: any
    formId: string,
    isV2Form?: boolean,
    assetsList?: any,
    importedAssets?: any,
    setImportedAssets?: any,
    viewFormProperties: boolean,
    setViewFormProperties: (value: boolean) => void
}

interface IFormData {
    width?: string;
    saveButtonText?: string;
    enableHeader?: boolean;
    enableSaveButton?: boolean;
    enableCompleteButton?: boolean;
    importedAssets?: any;
    completeButtonText?: string;
}
const { Option } = Select

export const FormPropertiesModal = (props: IProps) => {

    const { dispatch, formId, data: tabData, assetsList = {}, importedAssets, setImportedAssets, viewFormProperties, setViewFormProperties } = props
    const [widthUnit, setWidthUnit] = useState('')
    const [widthValue, setWidthValue] = useState('')
    const isV2Form = props.isV2Form

    const v2formProperties = useSelector((state: any) => state.formJson.formProperties);

    let [formPropertiesData, setFormPropertiesData] = useState<any>({})
    const formProperties = isV2Form ? v2formProperties : tabData?.formProperties;

    let [formData, setFormData] = useState<IFormData>({ ...formProperties });

    const formWidth: string = tabData && tabData.formProperties && tabData.formProperties.width;

    useEffect(() => {
        if (tabData?.formProperties?.importedAssets && setImportedAssets) {
            let assetIds = Object.keys((assetsList)).filter((assetId) => {
                if (tabData.formProperties.importedAssets.includes(assetId)) {
                    return assetId
                }
            })
            setImportedAssets(assetIds)
        } else if (setImportedAssets) {
            setImportedAssets([])
        }
    }, [assetsList])

    useEffect(() => {
        if (!widthUnit) {
            if (formWidth === undefined) {
                setWidthUnit('%');
            } else if (formWidth.endsWith('%')) {
                setWidthUnit('%');
                setWidthValue(formWidth.slice(0, -1));
            } else {
                setWidthUnit('css');
                setWidthValue(formWidth);
            }
        }
    }, [formWidth, widthUnit]);

    const handleOk = () => {
        if (isV2Form) {
            dispatch(updateV2FormProperties({ ...formProperties, ...formPropertiesData }));
        } else {
            if (tabData && formId) {
                dispatch(updateFormProperties({
                    formid: formId,
                    id: tabData?.id,
                    data: {
                        formProperties: {
                            ...tabData.formProperties,
                            ...formPropertiesData,
                            importedAssets: [...importedAssets]
                        }
                    },
                }));
            }
        }
        setViewFormProperties(false);
    };

    const handleChange = (data: any) => {
        let setData = { ...formData, ...data }
        setFormData(setData);
        setFormPropertiesData(setData)
    }

    const handleAssetChange = ((val: any) => {
        setImportedAssets(val)
    })

    const isEnabled = (formData: any, property: string): boolean => {
        return formData && formData.hasOwnProperty(property) ? formData[property] : true;
    }

    const isSaveButtonEnabled = isEnabled(formData, 'enableSaveButton');
    const isHeaderEnabled = isEnabled(formData, 'enableHeader');
    const isCompleteButtonEnabled = isEnabled(formData, 'enableCompleteButton');

    const selectAfter = (
        <Select
            value={widthUnit || '%'} style={{ width: 80 }} onChange={(val: string) => {
                setWidthUnit(val);
                setWidthValue('');
            }}
        >
            <Option value="%">%</Option>
            <Option value="css">css</Option>
        </Select>
    );

    return (
        <Modal
            id='formPropertiesModal'
            dataTestId='formPropertiesModal'
            title="FORM PROPERTIES"
            visible={viewFormProperties}
            onCancel={() => {
                setViewFormProperties(false);
            }}
            unmountOnCancel={true}
            footer={{
                enable: true,
                okText: 'Ok',
                onOk: handleOk, 
                cancelText: 'Cancel'
            }}
        >
            <Form className={"override-content"}>

                <Form.Item
                    label={<span className={style.labelName}>Form Width</span>}
                    validateStatus={
                        widthUnit === 'css' ?
                            (parseInt(widthValue) < 435 ? 'error' : '') :
                            (widthUnit === '%' && parseInt(widthValue) < 45 ? 'error' : '')
                    }
                    help={
                        widthUnit === 'css' ?
                            (parseInt(widthValue) < 435 ? 'Min value should be 435px' : '') :
                            (widthUnit === '%' && parseInt(widthValue) < 45 ? 'Width must be greater than 45%' : '')
                    }
                >
                    <Input
                        type={widthUnit === 'css' ? undefined : 'number'}
                        data-test-id="formWidth"
                        value={widthValue || ''}
                        onChange={(e) => setWidthValue(e.target.value)}
                        onBlur={(e) => {
                            if (widthUnit === 'css' ? parseInt(widthValue) < 435 : parseInt(widthValue) < 45) {
                                handleChange({
                                    width: formWidth
                                })
                            } else {
                                handleChange({ width: widthUnit === 'css' ? e.target.value : e.target.value ? `${e.target.value}${widthUnit}` : '' })
                            }
                        }}
                        addonAfter={selectAfter}
                    />
                </Form.Item>
                <Form.Item style={{ marginTop: '24px' }}>
                    <Checkbox
                        data-test-id="show_header"
                        defaultChecked={isHeaderEnabled}
                        onChange={(e) => handleChange({ enableHeader: e.target.checked })}
                    >Show Header</Checkbox>
                </Form.Item>
                {isHeaderEnabled &&
                    <div>
                        <Form.Item style={{ marginTop: '24px' }}>
                            <Checkbox
                                data-test-id="config_required"
                                defaultChecked={isSaveButtonEnabled}
                                onChange={(e) => handleChange({ enableSaveButton: e.target.checked })}
                            >Enable Save Button</Checkbox>
                        </Form.Item>
                        {
                            isSaveButtonEnabled &&
                            <Form.Item
                                label={<span className={style.labelName}>Save Text</span>}
                                validateStatus={(formData?.saveButtonText && formData.saveButtonText.length > 10) ? 'error' : ''}
                                help={(formData?.saveButtonText && formData.saveButtonText.length > 10) ? 'Character count should not exceed 10' : ''}
                            >
                                <Input
                                    data-test-id="function_display_name"
                                    defaultValue={(formData?.saveButtonText) || 'Save'}
                                    onChange={(e) => handleChange({ saveButtonText: e.target.value })}
                                    onBlur={(e) => {
                                        if (e.target.value.length > 10) {
                                            handleChange({ saveButtonText: "Save" });
                                        } else {
                                            handleChange({ saveButtonText: e.target.value })
                                        }
                                    }}
                                // maxLength={1}
                                />

                            </Form.Item>
                        }
                        <Form.Item style={{ marginTop: '24px' }}>
                            <Checkbox
                                data-test-id="config_required"
                                defaultChecked={isCompleteButtonEnabled}
                                onChange={(e) => handleChange({ enableCompleteButton: e.target.checked })}
                            >Enable Complete Button</Checkbox>
                        </Form.Item>
                        {
                            isCompleteButtonEnabled &&
                            <Form.Item
                                label={<span className={style.labelName}>Complete Text</span>}
                                validateStatus={(formData?.completeButtonText && formData.completeButtonText?.length > 10) ? 'error' : ''}
                                help={(formData?.completeButtonText && formData.completeButtonText.length > 10) ? 'Character count should not exceed 10' : ''}
                            >
                                <Input
                                    data-test-id="function_name"
                                    defaultValue={(formData?.completeButtonText) || 'Complete'}
                                    onChange={(e) => handleChange({ completeButtonText: e.target.value })}
                                    onBlur={(e) => {
                                        if (e.target.value.length > 10) {
                                            handleChange({ completeButtonText: "Complete" });
                                        } else {
                                            handleChange({ completeButtonText: e.target.value })
                                        }
                                    }}
                                // maxLength={10}
                                />
                            </Form.Item>
                        }
                    </div>
                }

                {
                    !isV2Form &&
                    <Form.Item
                        label={<span className={style.labelName}>Import Assets</span>}
                    >
                        <Select
                            mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Please select Assets"
                            onChange={((value: any) => { handleAssetChange(value) })}
                            defaultValue={importedAssets}
                            value={importedAssets}
                            filterOption={(inputValue, option) => {
                                if (option && option?.props && option.props.label) {
                                    let label: any = option?.props?.label ? option.props.label : "";
                                    return label.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            }}
                        >
                            {
                                assetsList && Object.keys(assetsList).map((item: any) => {
                                    let label = `${assetsList[item]?.json?.properties?.label ? assetsList[item]?.json?.properties?.label : assetsList[item].label}_${item}`
                                    return (
                                        <Option label={label} value={item}>{label}</Option>
                                    )
                                })
                            }
                        </Select>
                    </Form.Item>
                }
            </Form>
        </Modal>
    )
}
